import { formatCurrency, formatDate, findModuloValue } from "./formatters";

export function buildTemplateValues(contrato) {

  const modulosContrato = Array.isArray(contrato?.contratos_modulos) ? contrato.contratos_modulos : [];
  const valorModuloAcademico = findModuloValue(modulosContrato, ["academico", "académico"]);
  const valorModuloFinanciero = findModuloValue(modulosContrato, ["financiero", "financiera"]);
  const valorModuloAulaVirtual = findModuloValue(modulosContrato, ["aulavirtual", "aula virtual"]);

  return {
    "{{contrato.id}}": contrato.id,
    "{{contrato.titulo}}": contrato.titulo,
    "{{contrato.cliente_nombre}}": contrato.cliente_nombre ?? "",
    "{{contrato.cliente_nit}}": contrato.cliente_nit ?? "",
    "{{contrato.legal_nombre}}": contrato.legal_nombre,
    "{{contrato.legal_identificacion}}": contrato.legal_identificacion,
    "{{contrato.legal_lugar_expedicion_municipio}}": contrato.legal_lugar_expedicion_municipio,
    "{{contrato.legal_lugar_expedicion_departamento}}": contrato.legal_lugar_expedicion_departamento,
    "{{contrato.fecha_inicio}}": formatDate(contrato.fecha_inicio),
    "{{contrato.fecha_fin}}": formatDate(contrato.fecha_fin),
    "{{contrato.valor_total}}": formatCurrency(contrato.valor_total),
    "{{contrato.valor_mensual}}": formatCurrency(contrato.valor_mensual),
    "{{contrato.pago_inicial}}": formatCurrency(contrato.pago_inicial),
    "{{cliente.razon_social}}": contrato.cliente?.razon_social ?? "",
    "{{cliente.identificacion}}": contrato.cliente?.identificacion ?? "",
    "{{cliente.lugar_expedicion_municipio}}": contrato.cliente?.lugar_expedicion_municipio ?? "",
    "{{cliente.lugar_expedicion_departamento}}": contrato.cliente?.lugar_expedicion_departamento,
    "{{cliente.contacto_email}}": contrato.cliente?.contacto_email ?? "",
    "{{cliente.telefono}}": contrato.cliente?.telefono ?? "",
    "{{cliente.direccion}}": contrato.cliente?.direccion ?? "",
    "{{usuario.razon_social}}": contrato.usuario?.razon_social ?? "",
    "{{usuario.tipo_id}}": contrato.usuario?.tipo_id ?? "",
    "{{usuario.identificacion}}": contrato.usuario?.identificacion ?? "",
    "{{usuario.representante_nombre}}": contrato.usuario?.representante_nombre ?? "",
    "{{usuario.representante_id_label}}": contrato.usuario?.representante_id_label ?? "",
    "{{usuario.representante_id}}": contrato.usuario?.representante_id ?? "",
    "{{usuario.representante_identificacion}}": contrato.usuario?.representante_identificacion ?? "",
    "{{usuario.representante_lugar_expedicion}}": contrato.usuario?.representante_lugar_expedicion ?? "",
    "{{valor_total_fmt}}": formatCurrency(contrato.valor_total_fmt),
    "{{valor_mensual_fmt}}": formatCurrency(contrato.valor_mensual_fmt),
    "{{pago_inicial_fmt}}": formatCurrency(contrato.pago_inicial_fmt),
    "{{fecha_inicio_fmt}}": formatDate(contrato.fecha_inicio_fmt),
    "{{fecha_fin_fmt}}": formatDate(contrato.fecha_fin_fmt),
    "{{producto_nombre}}": contrato.producto_nombre,
    "{{academico_valor_fmt}}": formatCurrency(contrato.academico_valor_fmt),
    "{{financiero_valor_fmt}}": formatCurrency(contrato.financiero_valor_fmt),
    "{{aula_virtual_valor_fmt}}": formatCurrency(contrato.aula_virtual_valor_fmt),
    "{{proveedor.razon_social}}": contrato.proveedor?.razon_social ?? "",
    "{{proveedor.nit}}": contrato.proveedor?.nit ?? "",
    "{{proveedor.direccion}}": contrato.proveedor?.direccion ?? "",
    "{{proveedor.lugar_expedicion}}": contrato.proveedor?.lugar_expedicion ?? "",
    "{{proveedor.representante_nombre}}": contrato.proveedor?.representante_nombre ?? "",
    "{{proveedor.representante_cc}}": contrato.proveedor?.representante_cc ?? "",
    "{{ciudad_firma}}": contrato.ciudad_firma,
    "{{fecha_firma_fmt}}": formatDate(contrato.fecha_firma),
    "{{fecha_firma_larga}}": formatDate(contrato.fecha_firma),
    "{{academico_valor_fmt}}": formatCurrency(valorModuloAcademico),
    "{{financiero_valor_fmt}}": formatCurrency(valorModuloFinanciero),
    "{{aula_virtual_valor_fmt}}": formatCurrency(valorModuloAulaVirtual),
  };
}